import { useEffect, useState } from 'react';

const MAX_TIMER_DELAY_MS = 2_147_483_647;

export const isDaySwapEligibleWorkout = (activity, now = Date.now()) => {
  if (activity?.type !== 'workout') return false;
  if (activity?.is_template === true) return false;
  if (!activity?.source?.activity_plan_id) return false;
  if (activity?.status !== 'pending') return false;

  const dueAt = new Date(activity?.due_at).getTime();
  return Number.isFinite(dueAt) && dueAt >= Number(now);
};

export const useDaySwapEligibility = (activity) => {
  const [expirationTick, setExpirationTick] = useState(0);
  const dueAtValue = activity?.due_at;

  useEffect(() => {
    const dueAt = new Date(dueAtValue).getTime();
    const remaining = dueAt - Date.now();
    if (
      activity?.type !== 'workout'
      || activity?.is_template === true
      || !activity?.source?.activity_plan_id
      || activity?.status !== 'pending'
      || !Number.isFinite(dueAt)
      || remaining < 0
    ) {
      return undefined;
    }

    const timer = setTimeout(
      () => setExpirationTick(current => current + 1),
      Math.min(remaining + 1, MAX_TIMER_DELAY_MS),
    );
    return () => clearTimeout(timer);
  }, [
    activity?.type,
    activity?.is_template,
    activity?.source?.activity_plan_id,
    activity?.status,
    dueAtValue,
    expirationTick,
  ]);

  return isDaySwapEligibleWorkout(activity);
};
